module.exports = __webpack_public_path__ + "static/img/0.e830dfa9.jpg";